export const sirulaseema2 = {
  slug: "sirulaseema-2",
  name: "Sirulaseema-2",
  location: "Fast-growing South Hyderabad corridor",
  approval: "MUDA layout permission and TG RERA registration",
  acreage: "Open plot community",
  status: "Enquiries open",
  logo: "/projects/sirulaseema-2/logo.png",
  hero: "/projects/sirulaseema-2/aerial-amenity-campus.webp",
  summary:
    "Open plots in a fast-growing destination, presented as a balanced mix of nature, amenities, security, and investment value.",
  description:
    "Sirulaseema-2 has a mature amenity story: roads, sports, water tower, solar camera, orchard planting, pergolas, clubhouse, and swimming pool visuals all reinforce trust.",
  layoutImages: [{ src: "/projects/layouts/Sirulaseema2-Layout.webp", alt: "Sirulaseema-2 layout preview", label: "Layout preview" }],
  approvalImages: [{ src: "/projects/sirulaseema-2/approval.webp", alt: "Sirulaseema-2 MUDA and RERA approval details", label: "MUDA and RERA details" }],
  featuredImages: [
    {
      src: "/projects/sirulaseema-2/project-sign-road.webp",
      alt: "Sirulaseema-2 project sign and road",
      title: "Project identity on site",
      copy: "The sign, road, and surrounding planting make the development easy to recognize and trust."
    },
    {
      src: "/projects/sirulaseema-2/solar-camera.webp",
      alt: "Sirulaseema-2 solar camera",
      title: "Safety and monitoring",
      copy: "Security-oriented visuals support the direct customer relationship and long-term care story."
    },
    {
      src: "/projects/sirulaseema-2/swimming-pool.webp",
      alt: "Sirulaseema-2 swimming pool",
      title: "Amenity-led living",
      copy: "Lifestyle amenities give Sirulaseema-2 a stronger emotional hook than plot images alone."
    }
  ],
  galleryImages: [
    ["/projects/sirulaseema-2/aerial-amenity-campus.webp", "Aerial amenity campus"],
    ["/projects/sirulaseema-2/site-aerial.webp", "Site aerial view"],
    ["/projects/sirulaseema-2/project-sign-road.webp", "Project sign and internal road"],
    ["/projects/sirulaseema-2/cricket-net-aerial.webp", "Cricket net aerial view"],
    ["/projects/sirulaseema-2/clubhouse.webp", "Clubhouse"],
    ["/projects/sirulaseema-2/internal-road-tower.webp", "Internal road and water tower"],
    ["/projects/sirulaseema-2/road-crossing-aerial.webp", "Road crossing aerial"],
    ["/projects/sirulaseema-2/orchard.webp", "Orchard planting"],
    ["/projects/sirulaseema-2/solar-camera.webp", "Solar camera"],
    ["/projects/sirulaseema-2/gazebo-lawn.webp", "Gazebo lawn"],
    ["/projects/sirulaseema-2/play-area.webp", "Play area"],
    ["/projects/sirulaseema-2/lawn-gazebo.webp", "Lawn and gazebo"],
    ["/projects/sirulaseema-2/cricket-net-ground.webp", "Ground-level cricket net"],
    ["/projects/sirulaseema-2/pergola-walkway.webp", "Pergola walkway"],
    ["/projects/sirulaseema-2/game-court.webp", "Game court"],
    ["/projects/sirulaseema-2/white-pergola.webp", "White pergola"],
    ["/projects/sirulaseema-2/swimming-pool.webp", "Swimming pool"],
    ["/projects/sirulaseema-2/young-tree-road.webp", "Young trees along road"],
    ["/projects/sirulaseema-2/power-infra.webp", "Power infrastructure"],
    ["/projects/sirulaseema-2/utility-chamber.webp", "Utility chamber"],
    ["/projects/sirulaseema-2/utility-chamber-close.webp", "Utility chamber close view"]
  ],
  facts: [["Approval", "MUDA + RERA"], ["Asset", "Open plots"], ["Focus", "Investment"], ["Status", "Active"]],
  amenities: ["Internal roads", "Cricket net", "Swimming pool", "Solar camera", "Clubhouse", "Orchard planting"]
};
